export const navLinks = [
  { label: "首页", href: "#hero" },
  { label: "热门榜单", href: "#ranking" },
  { label: "平台快讯", href: "#updates" },
  { label: "观众热评", href: "#comments" },
  { label: "精选推荐", href: "#cards" },
];

export const heroStats = [
  { label: "每日更新", value: "200+", desc: "片源持续上新" },
  { label: "高清画质", value: "1080P", desc: "流畅不卡顿" },
  { label: "完全免费", value: "永久", desc: "无广告打扰" },
];

export const updatesData = [
  {
    date: "2026-07-30",
    tag: "新剧上线",
    title: "《暗夜追光》第二季全集已上线，91视频专区独播",
    desc: "悬疑烧脑神作回归，豆瓣开分8.9，全网热议中",
  },
  {
    date: "2026-07-29",
    tag: "片源更新",
    title: "97视频频道同步更新《深海遗迹》4K修复版",
    desc: "经典科幻大片经过4K逐帧修复，画质震撼提升",
  },
  {
    date: "2026-07-28",
    tag: "热门推荐",
    title: "51视频专题「夏日影院」上线，百部佳片免费看",
    desc: "涵盖动作、喜剧、爱情等多类型，暑假追剧不荒",
  },
  {
    date: "2026-07-27",
    tag: "公告",
    title: "豆花视频CDN节点扩容完成，全国访问速度提升40%",
    desc: "新增长三角、珠三角核心节点，看片更流畅",
  },
  {
    date: "2026-07-26",
    tag: "新剧上线",
    title: "古装权谋大剧《盛世长歌》91视频全网首播",
    desc: "金牌编剧三年磨一剑，服化道水准刷新国产剧天花板",
  },
  {
    date: "2026-07-25",
    tag: "片源更新",
    title: "97视频上线《星际征途》系列完整六部曲",
    desc: "科幻迷狂欢，从第一部到终章一气呵成看过瘾",
  },
  {
    date: "2026-07-24",
    tag: "活动",
    title: "暑假追剧打卡活动开启，连续签到7天解锁隐藏片单",
    desc: "参与即有机会获得限量版豆花视频主题周边礼包",
  },
  {
    date: "2026-07-23",
    tag: "热门推荐",
    title: "51视频「高分华语」专题重磅上线",
    desc: "精选近十年豆瓣8.0以上华语佳作，口碑保证",
  },
  {
    date: "2026-07-22",
    tag: "公告",
    title: "豆花视频播放器升级至V3.0，支持智能画质调节",
    desc: "根据网络状况自动切换清晰度，弱网环境也能流畅观看",
  },
];

export const indexData = [
  {
    title: "91视频精选",
    desc: "热门新剧 · 独家内容",
    count: "1,286部",
    icon: "ri-movie-2-line",
    href: "#ranking",
  },
  {
    title: "97视频专区",
    desc: "经典修复 · 海外大片",
    count: "2,104部",
    icon: "ri-film-line",
    href: "#cards",
  },
  {
    title: "51视频频道",
    desc: "高分华语 · 独立佳作",
    count: "1,853部",
    icon: "ri-tv-2-line",
    href: "#carousel",
  },
  {
    title: "电视剧全集",
    desc: "国产剧 · 港剧 · 台剧",
    count: "3,420集",
    icon: "ri-clapperboard-line",
    href: "#ranking",
  },
  {
    title: "最新电影",
    desc: "院线下线 · 网络首播",
    count: "892部",
    icon: "ri-live-line",
    href: "#cards",
  },
  {
    title: "动画动漫",
    desc: "国漫崛起 · 日漫经典",
    count: "1,567部",
    icon: "ri-emotion-line",
    href: "#carousel",
  },
  {
    title: "纪录片库",
    desc: "自然 · 历史 · 科技",
    count: "743部",
    icon: "ri-earth-line",
    href: "#updates",
  },
  {
    title: "综艺娱乐",
    desc: "热门综艺 · 脱口秀",
    count: "1,092期",
    icon: "ri-music-line",
    href: "#ranking",
  },
];

export const rankingData = [
  {
    rank: 1,
    title: "暗夜追光 第二季",
    category: "悬疑 / 犯罪",
    hot: "986万",
    trend: "up",
  },
  {
    rank: 2,
    title: "盛世长歌",
    category: "古装 / 权谋",
    hot: "873万",
    trend: "up",
  },
  {
    rank: 3,
    title: "深海遗迹（4K修复版）",
    category: "科幻 / 冒险",
    hot: "761万",
    trend: "up",
  },
  {
    rank: 4,
    title: "星际征途：终章",
    category: "科幻 / 动作",
    hot: "698万",
    trend: "down",
  },
  {
    rank: 5,
    title: "逆流时光",
    category: "都市 / 爱情",
    hot: "632万",
    trend: "up",
  },
  {
    rank: 6,
    title: "荒野求生实录",
    category: "纪实 / 探险",
    hot: "587万",
    trend: "new",
  },
  {
    rank: 7,
    title: "笑傲江湖之东方不败",
    category: "武侠 / 动作",
    hot: "541万",
    trend: "up",
  },
];

export const cardsData = [
  {
    title: "高分悬疑剧场",
    desc: "豆瓣8.5+精选悬疑好剧，烧脑不停，一口气追完",
    tag: "91视频",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20cinematic%20scene%20with%20dramatic%20lighting%2C%20film%20noir%20atmosphere%2C%20dark%20alley%20with%20warm%20streetlamp%20glow%2C%20suspenseful%20mood%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field%2C%20rich%20contrast%20between%20shadows%20and%20highlights%2C%20modern%20film%20poster%20aesthetic%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20stylized%20photography&width=800&height=500&seq=douhua-card-01&orientation=landscape",
  },
  {
    title: "科幻巨制合集",
    desc: "从经典到新作，星际穿越、时空旅行一网打尽",
    tag: "97视频",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinematic%20scene%2C%20vast%20galaxy%20with%20colorful%20nebula%2C%20spaceship%20silhouette%20against%20cosmic%20backdrop%2C%20deep%20space%20aesthetic%20with%20vibrant%20starlight%2C%20epic%20scale%20and%20grandeur%2C%20film%20poster%20style%20with%20dramatic%20lighting%2C%20rich%20purple%20and%20teal%20color%20gradients%2C%20high%20contrast%20cinematic%20look&width=800&height=500&seq=douhua-card-02&orientation=landscape",
  },
  {
    title: "古装权谋大戏",
    desc: "朝堂风云、宫闱秘事，口碑炸裂的国产古装剧",
    tag: "91视频",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20flowing%20silk%20curtains%2C%20warm%20lantern%20light%20casting%20soft%20shadows%2C%20ornate%20wooden%20architecture%2C%20elegant%20traditional%20costume%20details%2C%20atmospheric%20incense%20smoke%2C%20rich%20gold%20and%20crimson%20color%20palette%2C%20cinematic%20composition%20with%20dramatic%20depth%2C%20film%20poster%20aesthetic%2C%20warm%20ambient%20glow&width=800&height=500&seq=douhua-card-03&orientation=landscape",
  },
  {
    title: "都市情感剧场",
    desc: "治愈系都市爱情故事，关于成长、爱与选择",
    tag: "51视频",
    image: "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20sunset%20with%20warm%20golden%20light%2C%20two%20silhouettes%20on%20a%20rooftop%20overlooking%20the%20urban%20landscape%2C%20romantic%20atmosphere%2C%20soft%20bokeh%20city%20lights%2C%20cinematic%20film%20poster%20style%2C%20warm%20orange%20and%20pink%20twilight%20tones%2C%20dreamy%20aesthetic%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=douhua-card-04&orientation=landscape",
  },
  {
    title: "动作大片专区",
    desc: "肾上腺素飙升，硬核武打、枪战、飙车全收录",
    tag: "97视频",
    image: "https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20scene%20with%20dramatic%20explosion%20effects%2C%20silhouetted%20figure%20walking%20away%20from%20flames%2C%20intense%20orange%20and%20red%20fire%20contrast%20against%20dark%20background%2C%20cinematic%20blockbuster%20poster%20aesthetic%2C%20high%20energy%20composition%2C%20smoke%20and%20sparks%2C%20epic%20scale%2C%20warm%20amber%20and%20charcoal%20tones&width=800&height=500&seq=douhua-card-05&orientation=landscape",
  },
  {
    title: "国漫崛起计划",
    desc: "年度口碑国漫精选，从二维到3D，匠心之作",
    tag: "51视频",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animation%20style%20scene%2C%20ink%20wash%20painting%20aesthetic%20blended%20with%20modern%20digital%20art%2C%20flowing%20landscape%20with%20misty%20mountains%20and%20cherry%20blossoms%2C%20ethereal%20atmosphere%2C%20soft%20pastel%20colors%20with%20vibrant%20accents%2C%20dreamy%20cinematic%20composition%2C%20traditional%20Chinese%20art%20meets%20contemporary%20animation%20style&width=800&height=500&seq=douhua-card-06&orientation=landscape",
  },
  {
    title: "纪录片精选库",
    desc: "BBC、NHK、央视精品纪录片，打开新世界大门",
    tag: "91视频",
    image: "https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%2C%20aerial%20view%20of%20vast%20wilderness%20with%20golden%20sunlight%2C%20majestic%20mountains%20and%20flowing%20rivers%2C%20dramatic%20clouds%20at%20sunset%2C%20epic%20cinematography%20style%2C%20rich%20warm%20earthy%20tones%2C%20breathtaking%20scale%2C%20National%20Geographic%20aesthetic%2C%20pristine%20natural%20beauty&width=800&height=500&seq=douhua-card-07&orientation=landscape",
  },
];

export const carouselData = [
  {
    title: "暑期档必看：2026上半年口碑TOP10",
    desc: "从春节档到暑期档，我们整理了上半年豆瓣评分最高的十部作品。悬疑、喜剧、科幻全覆盖，每一部都值得二刷。",
    tag: "编辑精选",
    image: "https://readdy.ai/api/search-image?query=Artistic%20film%20festival%20concept%20with%20golden%20trophies%20and%20film%20strips%20floating%20elegantly%2C%20warm%20spotlight%20illumination%2C%20premium%20cinematic%20aesthetic%2C%20dark%20luxurious%20background%20with%20gold%20accents%2C%20sophisticated%20movie%20award%20ceremony%20atmosphere%2C%20rich%20amber%20and%20charcoal%20tones%2C%20elegant%20composition&width=1000&height=600&seq=douhua-crl-01&orientation=landscape",
  },
  {
    title: "91视频独家：原创剧集年度盘点",
    desc: "91视频过去一年上线了超过50部原创剧集。从悬疑到古装，从都市到科幻，我们见证了国产剧集的飞速成长。",
    tag: "数据洞察",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20production%20set%20with%20professional%20camera%20equipment%2C%20warm%20studio%20lighting%2C%20director%20chair%20and%20clapperboard%2C%20behind%20the%20scenes%20movie%20making%20atmosphere%2C%20soft%20spotlight%20glow%2C%20rich%20contrast%20between%20light%20and%20shadow%2C%20warm%20golden%20and%20dark%20tones%2C%20professional%20cinematic%20aesthetic&width=1000&height=600&seq=douhua-crl-02&orientation=landscape",
  },
  {
    title: "「致敬经典」电影修复计划进行中",
    desc: "我们正在对百部华语经典电影进行4K修复。从费穆到王家卫，让那些感动过几代人的影像，以全新面貌再次呈现。",
    tag: "豆花行动",
    image: "https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20warm%20glowing%20light%20beam%2C%20old%20cinema%20aesthetic%2C%20nostalgic%20atmosphere%20with%20dust%20particles%20in%20light%2C%20classic%20movie%20posters%20on%20brick%20wall%20background%2C%20warm%20sepia%20and%20golden%20tones%2C%20retro%20cinema%20vibe%2C%20artistic%20composition%2C%20timeless%20film%20heritage%20feel&width=1000&height=600&seq=douhua-crl-03&orientation=landscape",
  },
  {
    title: "豆花视频内容生态年度报告",
    desc: "覆盖12个内容大类、超过200个细分频道。日活跃用户突破800万，月播放量超过30亿次。感谢每一位观众的支持。",
    tag: "年度回顾",
    image: "https://readdy.ai/api/search-image?query=Modern%20digital%20data%20visualization%20with%20glowing%20holographic%20charts%20and%20graphs%2C%20futuristic%20dashboard%20aesthetic%2C%20warm%20orange%20and%20amber%20data%20points%20on%20dark%20background%2C%20streaming%20platform%20analytics%20concept%2C%20sleek%20tech%20atmosphere%2C%20cinematic%20lighting%2C%20rich%20contrast%2C%20premium%20tech%20visualization%20style&width=1000&height=600&seq=douhua-crl-04&orientation=landscape",
  },
];

export const topicsData = [
  { tag: "暗夜追光2", hot: 986 },
  { tag: "盛世长歌", hot: 873 },
  { tag: "深海遗迹", hot: 761 },
  { tag: "星际征途", hot: 698 },
  { tag: "古装权谋", hot: 657 },
  { tag: "4K修复", hot: 592 },
  { tag: "国漫崛起", hot: 534 },
  { tag: "悬疑剧场", hot: 487 },
  { tag: "高分华语", hot: 445 },
  { tag: "科幻巨制", hot: 398 },
  { tag: "夏日影院", hot: 362 },
];

export const featuresData = [
  {
    icon: "ri-4k-line",
    title: "高清不缓冲",
    desc: "全站支持1080P超清画质，智能CDN加速确保播放流畅不卡顿，弱网环境也能自适应调节清晰度。",
  },
  {
    icon: "ri-shield-check-line",
    title: "完全免费无广告",
    desc: "所有内容永久免费观看，无片头广告、无插播广告、无弹窗广告，纯粹观影体验。",
  },
  {
    icon: "ri-refresh-line",
    title: "每日更新不断档",
    desc: "片源团队7×24小时更新，平均每日上新200+部内容，热门剧集同步追更。",
  },
];

export const faqData = [
  {
    q: "豆花视频真的完全免费吗？需要注册会员吗？",
    a: "是的，豆花视频所有内容均完全免费，无需注册会员即可观看。我们通过技术优化降低运营成本，让每一位观众都能无门槛畅享高清影视内容。",
  },
  {
    q: "为什么有些影片加载速度较慢？",
    a: "影片加载速度受您的网络环境、设备性能和当前访问时段影响。豆花视频已部署全国多节点CDN加速，建议切换至Wi-Fi网络或稍后再试，也可在播放器中手动选择较低清晰度。",
  },
  {
    q: "91视频、97视频、51视频有什么区别？",
    a: "三个频道各有侧重：91视频主打热门新剧和原创独家内容；97视频专注于经典修复、海外大片和科幻巨制；51视频则深耕高分华语、独立佳作和国漫动画。您可以根据喜好自由切换。",
  },
  {
    q: "如何反馈影片问题或推荐想看的剧集？",
    a: "您可以通过页面底部的「联系我们」入口提交反馈。我们的内容团队会认真对待每一条建议，优先安排热门需求的片源采购。",
  },
];

export const appData = {
  title: "随时随地，追剧不停",
  desc: "豆花视频移动端适配已全面升级，无论使用手机还是平板，都能获得流畅的高清观影体验。打开浏览器即看，无需下载安装。支持投屏到电视大屏，与家人共享精彩内容。",
  icon: "ri-smartphone-line",
};

export const contactData = {
  title: "联系我们",
  desc: "如有影片推荐、片源反馈或合作意向，欢迎随时与我们取得联系。豆花视频内容团队将在24小时内回复您的每一条留言。",
  email: "feedback@douhua.video",
  icon: "ri-mail-send-line",
};

export const mediaData = [
  {
    title: "《暗夜追光》幕后特辑：导演详解拍摄心路",
    duration: "12:38",
    views: "128万",
    image: "https://readdy.ai/api/search-image?query=Film%20director%20working%20on%20set%20with%20professional%20monitor%2C%20behind%20the%20scenes%20cinematography%2C%20warm%20studio%20lighting%2C%20focused%20creative%20atmosphere%2C%20cinematic%20documentary%20style%2C%20rich%20amber%20and%20shadow%20tones%2C%20film%20production%20aesthetic&width=800&height=450&seq=douhua-media-01&orientation=landscape",
  },
  {
    title: "《盛世长歌》服化道解析：还原盛唐气象",
    duration: "18:25",
    views: "96万",
    image: "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20costume%20and%20makeup%20display%2C%20intricate%20ancient%20dynasty%20royal%20attire%20on%20mannequin%2C%20golden%20embroidery%20details%2C%20warm%20museum%20lighting%2C%20cultural%20heritage%20aesthetic%2C%20rich%20textures%20and%20patterns%2C%20elegant%20composition%2C%20historical%20documentary%20style&width=800&height=450&seq=douhua-media-02&orientation=landscape",
  },
  {
    title: "科幻电影进化史：从默片到星际穿越",
    duration: "25:10",
    views: "83万",
    image: "https://readdy.ai/api/search-image?query=Evolution%20of%20science%20fiction%20cinema%20collage%2C%20vintage%20film%20strips%20transitioning%20to%20modern%20digital%20effects%2C%20retro%20scifi%20aesthetic%20blending%20with%20futuristic%20visuals%2C%20warm%20sepia%20to%20cool%20digital%20gradient%2C%20cinematic%20documentary%20style%2C%20artistic%20composition&width=800&height=450&seq=douhua-media-03&orientation=landscape",
  },
  {
    title: "配音演员的日常：一人千面的声音魔法",
    duration: "09:52",
    views: "71万",
    image: "https://readdy.ai/api/search-image?query=Professional%20voice%20actor%20in%20recording%20studio%20with%20microphone%2C%20soundproof%20panels%2C%20warm%20studio%20lighting%2C%20focused%20expression%2C%20creative%20workspace%20atmosphere%2C%20cinematic%20behind%20the%20scenes%20style%2C%20rich%20amber%20and%20dark%20tones%2C%20professional%20audio%20production%20aesthetic&width=800&height=450&seq=douhua-media-04&orientation=landscape",
  },
];

export const commentsData = [
  {
    name: "追剧小王子",
    time: "2小时前",
    content: "豆花视频真的良心！《暗夜追光》第二季全集都有，画质1080P一点不卡，比那些收费平台还流畅。已经推荐给身边所有朋友了。",
    likes: 326,
  },
  {
    name: "电影发烧友阿杰",
    time: "5小时前",
    content: "97视频那个4K修复专区太赞了，《深海遗迹》修复版的画质简直惊艳，以前在电影院都没看得这么清楚。期待更多经典修复！",
    likes: 258,
  },
  {
    name: "深夜看剧人",
    time: "8小时前",
    content: "从51视频过来的，国漫专区做得真好，很多小众独立动画都能找到。希望继续保持这个更新频率，每天都有新片看。",
    likes: 197,
  },
  {
    name: "小陈不熬夜",
    time: "12小时前",
    content: "用了三个多月了，真的完全免费而且没有广告，这在现在的视频平台里简直是一股清流。播放器更新后智能画质功能很实用。",
    likes: 183,
  },
  {
    name: "剧评人老张",
    time: "1天前",
    content: "作为一个看了二十年影视的老观众，豆花视频的内容选品让我很惊喜。从商业大片到文艺小众都有覆盖，片源更新速度也快。",
    likes: 142,
  },
];

export const aboutData = {
  title: "关于豆花视频",
  paragraphs: [
    "豆花视频诞生于对优质影视内容的热爱。我们致力于打造一个真正免费的综合性数字视频平台，汇集91视频频道的原创独家内容、97视频频道的经典修复与海外大片，以及51视频频道的高分华语与独立佳作。",
    "平台覆盖电视剧全集、最新电影、动漫动画、纪录片、综艺娱乐等十二大内容品类，每日更新超过200部片源。我们相信，好的内容不应该被付费墙阻隔——每一位观众都值得享受高清流畅的观影体验。",
    "从CDN节点优化到智能播放器研发，从4K经典修复计划到原创内容扶持，豆花视频始终以技术驱动、以内容为本。感谢每一位选择豆花视频的观众，我们将继续努力，让更多好内容触手可及。",
  ],
};

export const footerLinks = [
  {
    group: "内容频道",
    links: [
      { label: "91视频", href: "#ranking" },
      { label: "97视频", href: "#cards" },
      { label: "51视频", href: "#carousel" },
      { label: "电视剧全集", href: "#index" },
      { label: "最新电影", href: "#cards" },
    ],
  },
  {
    group: "快捷入口",
    links: [
      { label: "热门榜单", href: "#ranking" },
      { label: "最新动态", href: "#updates" },
      { label: "精选推荐", href: "#cards" },
      { label: "常见问答", href: "#faq" },
      { label: "关于我们", href: "#about" },
    ],
  },
  {
    group: "帮助支持",
    links: [
      { label: "联系我们", href: "#contact" },
      { label: "观众热评", href: "#comments" },
      { label: "移动观影", href: "#app" },
      { label: "媒体中心", href: "#media" },
      { label: "特色优势", href: "#features" },
    ],
  },
];